export const PAYPAL = "Paypal"
export const TRANSFERWISE = "TransferWise"
export const ADVCASH = "AdvCash"
export const PAYONEER = "Payoneer"
export const REVOLUT = "Revolut"